const buildName = process.env.REACT_APP_BUILD_NAME;
const env = process.env;

let API, Loginlog, Client, logoPath, services_code, tenant, logoPixcel, CapatchaKey, submitRequestFromEmail, submitRequestToEmail;
const client_code_for_api = buildName;

if (buildName === 'UMC') {
    Loginlog = require('../assets/umc_logo.png');
    logoPath = require('../assets/umc_logo_small.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    Client = 1;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    services_code = 25075;
    logoPixcel = 200;
    submitRequestFromEmail = 'xxxxxxxxx';
    submitRequestToEmail = 'xxxxxxxxxxxx';
} else if (buildName === 'HMC') {
    Loginlog = require('../assets/Harley_Logo.png');
    logoPath = require('../assets/Harley_L.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    Client = 1;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    services_code = 274;
    logoPixcel = 200;
    submitRequestFromEmail = 'xxxxxxxxxxxx';
    submitRequestToEmail = 'xxxxxxxxxxxxxx';
} else if (buildName === 'IFC') {
    Loginlog = require('../assets/Polyclinica.ae_logo_horizontal-01.png');
    logoPath = require('../assets/Symbol_polyclinic.png');
    // Loginlog = require('../assets/himesheadlogo.png');
    // logoPath = require('../assets/himestestlogo.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    Client = 1;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    services_code = 691;
    logoPixcel = 200;
    submitRequestFromEmail = 'xxxxxxxxxxxxxx';
    submitRequestToEmail = 'xxxxxxxxxxxxxx';
}
else if (buildName === 'GCH') {
    Loginlog = require('../assets/gch.png');
    logoPath = require('../assets/gchl.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    Client = 1;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    services_code = 29973;
    logoPixcel = 90;
}
else if (buildName === 'SSMC') {
    Loginlog = require('../assets/himesheadlogo.png');
    logoPath = require('../assets/himestestlogo.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    Client = 1;
    services_code = 21;
    logoPixcel = 200;
}
else if (buildName === 'DMUH') {
    Loginlog = require('../assets/himesheadlogo.png');
    logoPath = require('../assets/himestestlogo.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    Client = 1;
    services_code = 12;
    logoPixcel = 200;
}

else if (buildName === 'MHH') {
    Loginlog = require('../assets/MHH-horizontal.png');
    logoPath = require('../assets/MHH-logo.png');
    API = process.env.REACT_APP_HIMES_NODE_URL;
    CapatchaKey = process.env.REACT_APP_CAPTCHA_KEY;
    tenant = process.env.REACT_APP_EXTERNAL_ID;
    Client = 1;
    services_code = 1349;
    logoPixcel = 200;
}


export const clientloginLogo = Loginlog;
export const clientLogo = logoPath
export const logoSize = logoPixcel;
export const HIMES_NODE_API = API;
export const consultation_services_code = services_code;
export const Client_id = Client;
export const tenant_id = tenant;
export const Capatcha_Key = CapatchaKey;
export const from_email = submitRequestFromEmail
export const to_email = submitRequestToEmail
export const clientname_for_api = client_code_for_api;

export const letterFormat = (inputLetter) => {
    if (!inputLetter || inputLetter.trim() === '') return '';
    const words = inputLetter.toLowerCase().split(' ');
    const formattedName = words.map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(' ');
    return formattedName;
};
